import { render, staticRenderFns } from "./ContactDetailsGrid.vue?vue&type=template&id=57a9926d"
import script from "./ContactDetailsGrid.vue?vue&type=script&lang=js"
export * from "./ContactDetailsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports